import React from "react"

const contentEmCss = theme => ({
  color: theme.colors.black,
  fontWeight: theme.fontWeights.bold,
  fontStyle: "normal",
})

export function Em({ children }) {
  return <em css={contentEmCss}>{children}</em>
}
